/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-03-01 15:51:48
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 08:24:43
 */
import Vue from "vue";
import VueRouter from "vue-router";
import routers from "./routers.js";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
const NotFoundComponent = { template: "<div>NotFoundComponent</div>" };

export default new VueRouter({
  mode: "hash", //'hash' | 'history' | 'abstract'
  routes: [
    { path: "/login", component: routers.Login },
    {
      path: "/",
      component: routers.Layout,
      redirect: "/login",
      children: [
        { path: "/adduser", component: routers.addUser },
        { path: "/accountinfo", component: routers.accountInfo },
        { path: "/menu", component: routers.menuManagement },
        { path: "/role", component: routers.roleManagement },
        { path: "/cleanerlist", component: routers.cleanerList },
        { path: "/companylist", component: routers.companyList },

        { path: "/addcoupon", component: routers.addCoupon },
        { path: "/couponconfig", component: routers.couponConfig },
        { path: "/conpondetail", component: routers.couponDetail },
        { path: "/homemanage", component: routers.homeManage },
        { path: "/scenelist", component: routers.sceneList },

        { path: "/productlist", component: routers.productList },
        { path: "/categorylist", component: routers.categoryList },

        { path: "/orderlist", component: routers.orderList },
        { path: "/orderdetail", component: routers.orderDetail },

        { path: "/recyclelist", component: routers.recycleList },
        { path: "/recycledetail", component: routers.recycleDetail },

        { path: "/withdrawreview", component: routers.withdrawList },

        { path: "/systemconfig", component: routers.systemConfig },
        { path: "/partnerlist", component: routers.partnerList },

        { path: "/usermanagement", component: routers.userManagement },
        { path: "/useradd", component: routers.userAdd },

        { path: "/resetpasswd", component: routers.resetPassword },
      ],
    },
    {
      path: "/404",
      name: "notFound",
      component: routers.NotFound,
    },
    { path: "*", component: routers.NotFound },
  ],
});
